import { IAppState } from '../../../AppModulesWrapper';

import { selectActiveServiceId } from '../../reducers/v2/promotion/selectors';
import { selectPromotionServiceId } from './selectPromotionServiceId';
import { EServiceId } from '../../types/reducers/publishTerms';
import { selectIsAuctionSelected } from '../auction';

export function selectActiveOrPromotionServiceId(state: IAppState): EServiceId | null {
  const isAuctionSelected = selectIsAuctionSelected(state);

  // Выбрана карточка стандартного с инпутом ставки или пакет на топ/премиум с инпутом ставки
  if (isAuctionSelected) {
    return selectPromotionServiceId(state);
  }

  // Выбрана услуга топ/премиум/стандартное. Инпут ставки не отображается
  return selectActiveServiceId(state);
}
